import React from 'react';
import { Card, Typography, Box } from '@mui/material';
import { IconHeartbeat } from '@tabler/icons-react';
import { styled } from '@mui/material/styles';
import dayjs from 'dayjs';

const StyledIcon = styled(IconHeartbeat)(() => ({
    width: '100px',
    height: '100px'
}));

const getECGTitle = (type) => {
    switch (type) {
        case 'ECG_1L':
            return 'ECG 1 Derivação';
        case 'ECG_12L':
            return 'ECG 12 Derivações';
        case 'ECG_HOLTER':
            return 'Holter ECG';
        default:
            return 'ECG';
    }
};

const ECGTestCard = ({ type, date, data, onClick }) => {
    const formattedDate = dayjs(date).format('DD/MM/YYYY');
    const indication = data?.clinicalInfo ?? '—';

    return (
        <div
            role="button"
            tabIndex={0}
            onClick={onClick}
            onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') onClick();
            }}
            style={{ cursor: 'pointer' }}
        >
            <Card
                elevation={0}
                sx={{
                    display: 'flex',
                    backgroundColor: '#ffffff',
                    boxShadow: 'none',
                    border: '2px solid #0A579B',
                    transition: '0.2s ease-in-out',
                    '&:hover': {
                        boxShadow: 6,
                        transform: 'scale(1.02)'
                    }
                }}
            >
                <Box
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        padding: '20px'
                    }}
                >
                    <StyledIcon sx={{ color: '#0A579B' }} />
                </Box>

                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'space-around',
                        padding: '10px'
                    }}
                >
                    <Typography variant="h2" sx={{ color: '#0A579B' }}>
                        {getECGTitle(type)}
                    </Typography>

                    <Typography variant="h5">{formattedDate}</Typography>

                    <Typography variant="h5">Indicação: {indication}</Typography>
                </Box>
            </Card>
        </div>
    );
};

export default ECGTestCard;
